module.exports = __webpack_public_path__ + "img/thumb_PlayStation4.db5f5222.png";